(() => {
  const key = 'nekupi-wishlist-v1';
  const validPath = value => {
    try { const u = new URL(value, location.origin); return u.origin === location.origin && /\/products\/[^/]+/.test(u.pathname) ? u.pathname : null; } catch { return null; }
  };
  const validImage = value => {
    try { const u = new URL(value, location.origin); return u.protocol === 'https:' && (u.origin === location.origin || u.hostname === 'cdn.shopify.com') ? u.href : ''; } catch { return ''; }
  };
  const load = () => {
    try { const list = JSON.parse(localStorage.getItem(key) || '[]'); return Array.isArray(list) ? list.filter(p => p && typeof p.handle === 'string' && typeof p.title === 'string' && validPath(p.url)).slice(0,100) : []; } catch { return []; }
  };
  const save = list => {
    localStorage.setItem(key,JSON.stringify(list));
    window.dispatchEvent(new Event('nekupi:wishlist'));
  };
  const count = () => document.querySelectorAll('[data-wish-count]').forEach(el => { const n=load().length;el.textContent=n ? '('+n+')' : ''; });
  window.addEventListener('nekupi:wishlist',count);
  window.addEventListener('storage',event => { if(event.key===key || event.key===null) window.dispatchEvent(new Event('nekupi:wishlist')); });
  window.addEventListener('pageshow',() => window.dispatchEvent(new Event('nekupi:wishlist')));
  class NekupiWish extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();this.abort=new AbortController();const options={signal:this.abort.signal};
      this.hidden=false;this.refresh();
      this.querySelector('button').addEventListener('click',() => {
        const list=load(), index=list.findIndex(p=>p.handle===this.dataset.handle), status=this.querySelector('[role=status]');
        status.textContent='';
        if(index>=0) list.splice(index,1);
        else {
          if(list.length>=100){status.textContent=this.dataset.limit;return;}
          list.unshift({handle:this.dataset.handle,title:this.dataset.title,url:this.dataset.url,image:this.dataset.image});
        }
        try{save(list);}catch{status.textContent=this.dataset.error;}
      },options);
      window.addEventListener('nekupi:wishlist',()=>this.refresh(),options);
    }
    disconnectedCallback(){this.abort?.abort();}
    refresh(){const saved=load().some(p=>p.handle===this.dataset.handle), button=this.querySelector('button');button.setAttribute('aria-pressed',String(saved));button.setAttribute('aria-label',(saved?this.dataset.remove:this.dataset.add)+': '+this.dataset.title);const label=this.querySelector('[data-wish-label]');if(label)label.textContent=saved?this.dataset.saved:this.dataset.add;}
  }
  class NekupiWishlist extends HTMLElement {
    connectedCallback(){this.abort?.abort();this.abort=new AbortController();window.addEventListener('nekupi:wishlist',()=>this.render(),{signal:this.abort.signal});this.render();}
    disconnectedCallback(){this.abort?.abort();}
    render(){
      const grid=this.querySelector('[data-wish-list]'),status=this.querySelector('[data-list-status]'), list=load();grid.replaceChildren();status.textContent=list.length?'':this.dataset.empty;
      list.forEach(p=>{
        const article=document.createElement('article');article.className='nkw-item';article.dataset.handle=p.handle;
        const a=document.createElement('a');a.href=validPath(p.url);
        const src=validImage(p.image);if(src){const img=document.createElement('img');img.src=src;img.alt='';img.loading='lazy';a.append(img);}
        const h=document.createElement('h2');h.textContent=p.title;const view=document.createElement('span');view.textContent=this.dataset.view;a.append(h,view);
        const button=document.createElement('button');button.type='button';button.textContent=this.dataset.remove;button.setAttribute('aria-label',this.dataset.remove+': '+p.title);
        button.addEventListener('click',()=>{const index=list.findIndex(x=>x.handle===p.handle);try{save(load().filter(x=>x.handle!==p.handle));const buttons=grid.querySelectorAll('button');if(buttons.length)buttons[Math.min(index,buttons.length-1)].focus();else{status.tabIndex=-1;status.focus();}}catch{status.textContent=this.dataset.error;}});
        article.append(a,button);grid.append(article);
      });
    }
  }
  if(!customElements.get('nekupi-wish'))customElements.define('nekupi-wish',NekupiWish);
  if(!customElements.get('nekupi-wishlist'))customElements.define('nekupi-wishlist',NekupiWishlist);
  const params=new URLSearchParams(location.search), field=document.querySelector('[data-request-product]'),reference=document.querySelector('[data-request-reference]');
  if(field && !field.value)field.value=(params.get('producto')||'').slice(0,250);
  if(reference)reference.value=(params.get('referencia')||'').slice(0,250);
  count();
})();
